<nav class="navbar navbar-dark d-block d-lg-none">
  <div class="container">
    <ul class="nav nav-justified w-100">
      <!-- Home button -->
      <li class="nav-item">
        <a
          [routerLinkActiveOptions]="{ exact: true }"
          class="nav-link d-flex align-items-center justify-content-center"
          routerLink="/"
          routerLinkActive="active"
        >
          <fa-icon icon="home"></fa-icon>
        </a>
      </li>

      <!-- Search button -->
      <li class="nav-item">
        <a
          class="nav-link d-flex align-items-center justify-content-center"
          routerLink="/search"
          routerLinkActive="active"
        >
          <fa-icon icon="search"></fa-icon>
        </a>
      </li>

      <!-- User profile button (only when logged in) -->
      <li *ngIf="user" class="nav-item">
        <a
          (click)="openUserGallery()"
          class="nav-link d-flex align-items-center justify-content-center user-avatar-link"
        >
          <div class="avatar-container">
            <astrobin-avatar [link]="false" [user]="user"></astrobin-avatar>
          </div>
        </a>
      </li>

      <!-- Forums button -->
      <li class="nav-item">
        <a
          class="nav-link d-flex align-items-center justify-content-center"
          routerLink="/forum"
          routerLinkActive="active"
        >
          <fa-icon icon="comments"></fa-icon>
        </a>
      </li>

      <!-- Marketplace button -->
      <li class="nav-item">
        <a
          [routerLink]="['/equipment/marketplace']"
          class="nav-link d-flex align-items-center justify-content-center"
          routerLinkActive="active"
        >
          <fa-icon icon="shopping-cart"></fa-icon>
        </a>
      </li>
    </ul>
  </div>
</nav>
